module.exports = __webpack_public_path__ + "static/login-39ab9bcaec0d2fdbd6c4a449d25f3f9d.jpg";